"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var modulesToJSONSchema = function modulesToJSONSchema(_ref) {
  var supportedModules = _ref.supportedModules,
    modules = _ref.modules;
  if (!modules) return null;
  return modules.map(function (module) {
    var contentType = module.contentType;
    var schemaProcessor = supportedModules[contentType];
    return schemaProcessor ? schemaProcessor(module) : null;
  }).filter(function (schema) {
    return schema;
  });
};
var _default = modulesToJSONSchema;
exports["default"] = _default;